import React, { Component, Fragment } from 'react';
import { InputItem, Toast, Modal } from 'antd-mobile';

import api from 'Api';
import { publicKeyDer } from 'Utils/encryption';

import styles from './index.less';

class Activation extends Component {
  constructor(props){
    super(props);

    this.handleAgree = this.handleAgree.bind(this);
    this.getCode = this.getCode.bind(this);
    this.clickActivation = this.clickActivation.bind(this);
    this.showAgreement = this.showAgreement.bind(this);
    this.state = {
      title: props.title || '手机号注册',
      mainBgColor: props.mainBgColor || '#F2CDA1, #C48C53',
      mainTextColor: props.mainTextColor || '#BA8554',
      // 展示用户协议
      showAgreement: false,
      codeText: '获取验证码',
      // 是否同意用户协议
      agreeType: true,
      // 注册按钮高亮
      activationSelect: false,
      // 获取验证码按钮高亮
      codeSelect: false,
      tel: '',
      code: '',
      countDown: '',
      isPhoneFocus: false,
      isCodeFocus: false,
      scrollTop: document.querySelector('html').scrollTop || document.querySelector('body').scrollTop,
    };
  }

  componentDidMount() {
    if(this.maskPopupWrap){
      this.maskPopupWrap.addEventListener('touchmove', (ev) => {
        ev.preventDefault();
      });
    }
    const { scrollTop } = this.state;
    const height = document.documentElement.clientHeight;
    document.querySelector('html').style.height = `${height}px`;
    document.querySelector('html').style.overflow = 'hidden';
    document.querySelector('body').style.height = `${height}px`;
    document.querySelector('body').style.overflow = 'hidden';
    document.querySelector('#root').style.marginTop = `${- scrollTop  }px`;
  }

  componentWillUnmount() {
    const { scrollTop, countDown } = this.state;
    clearInterval(countDown);
    document.querySelector('#root').style.marginTop = 0;
    document.querySelector('html').style.height = 'auto';
    document.querySelector('html').style.overflow = 'auto';
    document.querySelector('body').style.height =  'auto';
    document.querySelector('body').style.overflow = 'auto';
    document.querySelector('html').scrollTop = scrollTop;
    document.querySelector('body').scrollTop =  scrollTop;
  }

  onPhoneBlur() {
    this.setState(()=>({
      isPhoneFocus: false
    }));
    setTimeout(()=>{
      const { isCodeFocus } = this.state;
      if(!isCodeFocus){
        document.querySelector('html').scrollTop = '0';
        document.querySelector('body').scrollTop =  '0';
      }
    },100);
  }

  onPhoneFocus() {
    this.setState(()=>({
      isPhoneFocus: true
    }));
  }

  onCodeBlur() {
    this.setState(()=>({
      isCodeFocus: false
    }));
    setTimeout(()=>{
      const { isPhoneFocus } = this.state;
      if(!isPhoneFocus){
        document.querySelector('html').scrollTop = '0';
        document.querySelector('body').scrollTop =  '0';
      }
    },100);
    
  }

  onCodeFocus() {
    this.setState(()=>({
      isCodeFocus: true
    }));
  }

  // 获取验证码
  getCode() {
    const { codeSelect, tel } = this.state;
    const { wapLogin } = this.props;
    if(!codeSelect){
      if (this.checkTel()){
        this.countDown();
        this.setState(() => ({
          codeSelect: true,
        }));
        if (wapLogin) {
          // 发送验证码
          api.getMobileCode({
            body: publicKeyDer({m: tel})
          }).then(res1 => {
            if (res1.code !== 0) {
              Modal.alert('温馨提示', res1.message);
            }
          });
        } else {
          api.getCode({
            mobile: tel,
          }).then((res) => {
            if (Number(res.code) !== 0) {
              Modal.alert('温馨提示', res.message);
            }
          });
        }
      }
    }
  }

  // 倒计时
  countDown() {
    let count = 61;
    const countDown =  window.setInterval(() => {
      if(count > 1){
        count -= 1;
        this.setState(() => ({
          codeText: `${count}s`,
        }));
      }else{
        clearInterval(countDown);
        this.setState(() => ({
          codeText: '获取验证码',
          codeSelect: false,
        }));
      }
    },1000);
    this.setState(() => ({
      countDown
    }));
  }

  // 校验手机号
  checkTel(showToast = true) {
    const telReg = /1\d{10}/;
    // 验证手机号
    const { tel } = this.state;
    if (!tel) {
      if (showToast) {
        Toast.info('请输入正确的手机号', 3);
      }
      return false;
    }
    if (!telReg.test(tel)) {
      if (showToast) {
        Toast.info('手机号格式有误', 3);
      }
      return false;
    }
      return true;
    
  }

  // 同意协议
  handleAgree() {
    const { agreeType, code } = this.state;
    if(!agreeType && this.checkTel(false) && code.length === 6){
      this.setState(() => ({
        agreeType: !agreeType,
        activationSelect: true,
      }));
    }else{
      this.setState(() => ({
        agreeType: !agreeType,
        activationSelect: false,
      }));
    }

  }


  // 注册
  clickActivation() {
    const { code, agreeType, tel} = this.state;
    const { wapLogin } = this.props;
    if (this.checkTel() && code && agreeType){
      if (wapLogin) {
        api.verifyMobileCode({
          body: publicKeyDer({m: tel, c: code})
        }).then(res1 => {
          if (res1.code === 0) {
            const { hideActivation, callBack } = this.props;
            callBack(res1.data);
            hideActivation('success');
            Toast.info('登录成功', 3);
          }
        });
      } else {
        api.accountBind({
          mobile: tel,
          code,
        }).then((res) => {
          if (Number(res.code) === 0) {
            const { hideActivation, callBack } = this.props;
            callBack();
            hideActivation('success');
            if(res.message === 'success'){
              Toast.info('注册成功', 3);
            }
          } else {
            Modal.alert('温馨提示', res.message);
          }
        });
      }
    }

  }

  // 展示用户协议
  showAgreement() {
    const { showAgreement } = this.state;
    this.setState(() => ({
      showAgreement: !showAgreement,
    }));
  }


  render(){
    const { mainBgColor, title, mainTextColor, tel, agreeType, code, codeSelect, codeText, activationSelect, showAgreement } = this.state;
    return(
      <Fragment>
        <div className={styles.maskPopup} style={{ height: document.documentElement.clientHeight }} ref={el => {this.maskPopupWrap = el}}>
          <div className={styles.maskWrapper}>
            <div className={styles.maskInner}>
              <div className={styles.topWrapper}>
                <div
                  className={styles.maskTop}
                  style={{backgroundImage: `linear-gradient(136deg, ${mainBgColor})`}}
                >
                  {title}
                </div>
              </div>
              <div className={styles.maskContent}>
                <div className={styles.descList}>
                  <div className={styles.descWrapper}>
                    <div
                      className={styles.title}
                      style={{color: mainTextColor}}
                    >
                      *手机号
                    </div>
                    <InputItem
                      type="phone"
                      maxLength="11"
                      placeholder="请输入手机号"
                      value={tel}
                      onChange={(e) => {
                        const ev = e.replace(/\s+/g,"");
                        if(ev.length > 11){
                          return;
                        }
                        if(ev.length === 11 && agreeType && code.length === 6){
                          this.setState({
                            tel: ev,
                            activationSelect: true,
                          });
                        }else{
                          this.setState({
                            tel: ev,
                            activationSelect: false,
                          });
                        }
                      }}
                      onFocus={()=>this.onPhoneFocus()}
                      onBlur={()=>this.onPhoneBlur()}
                    />
                  </div>
                </div>
                <div className={styles.descList}>
                  <div className={styles.descWrapper}>
                    <div
                      className={styles.title}
                      style={{color: mainTextColor}}
                    >
                      *验证码
                    </div>
                    {/* <input type="text" placeholder={'请输入短信验证码'}/> */}
                    <InputItem
                      type="digit"
                      maxLength="6"
                      placeholder="请输入短信验证码"
                      value={code}
                      onChange={(e) => {
                        if(e.length > 6){
                          return;
                        }
                        if(e.length !== 6){
                          this.setState({
                            code: e,
                            activationSelect: false,
                          });
                        }else if(agreeType && this.checkTel()){
                            this.setState({
                              code: e,
                              activationSelect: true,
                            });
                          }

                      }}
                      onFocus={()=>this.onCodeFocus()}
                      onBlur={()=>this.onCodeBlur()}
                    />
                    <div
                      className={`${styles.codeText} ${ codeSelect ? styles.select : ''}`}
                      style={{backgroundImage: `linear-gradient(136deg, ${mainBgColor})`}}
                      onClick={this.getCode}
                    >
                      {codeText}
                    </div>
                  </div>
                </div>
                <div className={styles.agreeWrapper}>
                  <div
                    className={styles.agree}
                    style={{backgroundImage: `linear-gradient(136deg, ${agreeType ? mainBgColor : '#D9D9D9, #ABABAB'})`}}
                    onClick={this.handleAgree}
                  >
                    <div className={styles.icon} />
                  </div>
                  <div className={styles.agreeText}>
                    我已同意并且接受
                    <span
                      onClick={this.showAgreement}
                    >
                      《首客首享用户注册协议》
                    </span>
                  </div>
                </div>
                <div
                  className={`${styles.activation}`}
                  style={{backgroundImage: `linear-gradient(136deg, ${activationSelect ? mainBgColor : '#D9D9D9, #ABABAB'})`}}
                  onClick={this.clickActivation}
                >
                  注册
                </div>
              </div>
            </div>
            <div
              className={styles.closeBtnWrap}
              onClick={()=>{
                   const { hideActivation } = this.props;
                   hideActivation();
                 }}
            />
          </div>
        </div>
        {
          showAgreement
          ?
            <div className={styles.agreement}>
              <div className={styles.backWrapper}>
                <div
                  onClick={this.showAgreement}
                  className={styles.back}
                >
                  返回
                </div>
                <div className={styles.textWrapper}>
                  <div className={styles.title}>会员条款与细则</div>
                  <div className={styles.content}>
                    <p>
                      欢迎您成为“首享会”会员。加入“首享会”即表示您同意遵守以下条款和细则，因此，请仔细阅读并全面了解。
                    </p>
                    <p className={styles.marginTop20}>
                      “首客首享”首享会会员体系（以下简称“首享会”）会员资格及其优惠由北京首旅慧联科技有限责任公司（以下简称“首旅慧联”）及其合作企业联合提供。首旅慧联有权单方面酌情增删合作企业及品牌。
                    </p>
                    <p
                      className={styles.marginTop20}
                    >
                      <b>会员体系主办方。</b>本会员体系由北京首旅慧联科技有限责任公司（以下简称“首旅慧联”）实施。
                    </p>
                    <p>
                      <b>会员资格与费用。</b>本会员体系中的会员资格适用于条款与附则中所指的个人（以下称“您”）。您必须至少年满 18 周岁或达到所居住地区的法定成年年龄，以二者中较大年龄为准。您只能拥有一个账户。公司和/或其它实体不得参加。本会员体系不收入会费。
                    </p>
                    <p>
                      <b>会员体系有效性；条款与附则变动。</b>首旅慧联保留自行决定的权利，可随时修改、更改或更新这些条款与附则，和/或添加、修改、限制、暂停、中止或取消本会员体系，包括符合标准的积分兑换及积分数、会员级别、礼遇或其他优惠，即使此类变更可能会影响已累积的奖励或积分价值。请查看页脚处的最后更新日期，确认是否有本条款与附则或会员体系变更的通知。若页脚处表明本条款与附则或本会员体系已发生变更，请立即阅读。在我们发布此类修改、更改或更新通知，且您已阅读完修订版条款与附则或会员体系信息之后，若您选择保留首享会会员身份，则代表您同意遵循修订后的条款与附则或按照修订加入会员体系。当前会员条款与附则取代所有之前发布的条款与附则。
                    </p>
                    <p>
                      <b>会员资格取消。</b>首旅慧联保留出于以下原因（但不仅限于以下原因）取消首享会会员资格和废除任何会员累积的任何和所有未兑换的首享会会员相关礼遇及积分：<br />
                      1) 违反条款与细则；<br />
                      2) 信息中存在虚假陈述，或对本会员体系有不当使用；<br />
                      3) 会员礼遇的使用违反任何国家、省或本地法律或法规；<br />
                      4) 未支付应付的费用；<br />
                      5) 向参与首享会会员体系的企业支付的支票由于资金不足被退回，或者由于任何原因该支票无效；<br />
                      6) 涉及本会员体系任何内容的欺诈或滥用；<br />
                      7) 单个会员拥有一个以上的有效账户；<br />
                      8) 对首旅慧联或参与首享会会员体系的企业旗下员工进行身体、言语或书面的伤害；<br />
                      9) 以任何其他形式对本会员体系或任何联盟成员造成损害。所有上述会员资格取消条件由首旅慧联全权决定。
                    </p>
                    <p>
                      <b>成长值。</b>自加入首享会之日起，您即可以开始赚取成长值。您在首享会的合作企业下每消费一元则自动获得一成长值。您的成长值将决定您的会员等级和礼遇。
                    </p>
                    <p>
                      <b>会员等级。</b>您将依据账户内的成长值享受相应的会员等级和该会员等级所匹配的会员礼遇。首旅慧联保留调整会员等级获得条件和对会员礼遇增加、删减、修改礼遇适用范围的权利。
                      <br />会员等级获得条件：<br />
                      预享会员: 注册并绑定手机即可成为预享会员；<br />
                      优享会员: 预享卡有效期内成长值大于99即升级为优享会员；<br />
                      悦享会员: 优享卡有效期内成长值大于299即升级为悦享会员；<br />
                      致享会员: 悦享卡有效期内成长值大于599即升级为致享会员；<br />
                      尊享会员: 成长值超过1099即有机会被邀请成为尊享会员。
                    </p>
                    <p>
                      <b>会员等级有效期。</b>会员等级有效期根据成长值而变动，详见成长值获取规则。
                    </p>
                    <p>
                      <b>积分和成长值赚取限制。</b>首旅慧联保留添加、删减或更改会员积分和成长值赚取途径的权利。删减或更改会员积分和/或成长值赚取方式包括但不限于：取消合作企业的特定商品获得积分和和/或成长值的资格、更改每一元消费可以获得的积分和/或成长值数额等等。
                    </p>
                    <p>
                      <b>积分调整。</b>首享会账户中的积分可能根据实际消费情况、任何会员体系的调整和更改而变动。如果您在首享会合作企业退货或者取消预定，您账户内的因为该笔消费而增加的积分会被扣除。如果您认为您的账户上反映的积分信息不正确，请与首享会客户服务专线联系。首旅慧联保留对异常积分账户调查、冻结及永久封禁的权利。一旦发现会员有利用违规手段骗取积分的行为，首旅慧联有权不经事先通知而立即注销卡内积分，取消持卡人会员资格且追究相关法律责任。
                    </p>
                    <p>
                      <b>积分自身不具有价值。</b>首享会会员积分不可兑换现金或任何其他形式的积分，并且只有根据本会员体系的条款与细则兑换奖励之后才具有价值。积分不具有固定或可确定的现金价值。会员对累积的积分不享有所有权，累积的积分也不构成会员的财产。有关的首享会积分营销资料中使用的“赚取”和“赚”意思为“收集”，不能据此推断该积分具有任何价值，除非将它们用于兑换。积分不能购买或销售，也不能转让，除非条款与细则中另作说明。
                    </p>
                    <p>
                      <b>积分奖励的其他用途。</b>首旅慧联可以使用积分作为奖励、奖赏或激励授予顾客或员工，与首旅慧联达成协议的其他公司也可将其用于对顾客和员工的奖励。
                    </p>
                    <p>
                      <b>积分过期。</b>积分过期政策：每月最后一个自然日系统会自动清除上一年同月份之前生成的积分。
                    </p>
                    <p>
                      <b>数据隐私。</b>您在申请会员资格或长期享受会员优惠礼遇的过程中，为了使首旅慧联能够按会员条款履行各项义务，您接受并且明确授权您在入会时或行使会员资格所享受的各种优惠的过程中所提供的个人信息：<br />
                      (i) 由首旅慧联、其下属机构、附属机构和/或合作企业进行数据控制和管理；<br />
                      (ii) 可以传送给此会员体系下首旅慧联的任何第三方合作伙伴，或者代表本公司处理您的个人信息的第三方，受相关法律要求、或在公司重组、合并或收购的情况下，出于会员记录管理、宾客服务、广告、市场营销和通信目的使用这些信息。我们或这些机构可能会通过邮寄、传真、电话或电子邮件与您联系。另外，我们的合作公司可能向您发送您感兴趣或有价值的产品或服务信息，因此我们会向这些公司提供您的联系方式。
                    </p>
                    <p>
                      <b>数据访问权限。</b>您有权获取您的个人信息，但需要向首旅慧联发送书面申请。您有责任维护您的会员账户和密码使用权限及其保密性，并且同意对使用该密码进行的任何活动负责。
                    </p>
                    <p>
                      <b>特殊会员活动与服务。</b>您有资格享受首享会的特殊会员活动和优惠。具体的优惠和活动经常变更，并且随企业、时间和地理区域而不同。
                    </p>
                    <p>
                      <b>通讯未达。</b>对于在通信、客户请求和传输中出现的信息丢失情况，或因通讯内容不完整、非法、延误、遗失或被窃而导致的损失，首旅慧联概不负责。
                    </p>
                    <p>
                      <b>不提供商品保证。</b>首旅慧联、其所属公司、子公司、附属公司对合作企业的商品、产品或服务不作任何形式的明示或暗示保证、担保或声明；而且对由于商品使用及其缺陷或故障而造成的任何损失、费用（包括但不仅限于任何律师费）、意外或不便，也概不负责。特别是对用于特定用途商品暗示的适销性或适用性完全免责。
                    </p>
                    <p>
                      <b>会员体系违规使用。</b>如有任何会员有不良行为、欺诈、滥用首享会提供的优惠及奖励，首旅慧联或合作伙伴有权向其索赔。索赔金额不设上限，包括兑换奖励的全价、相应产品或服务的费用，以及首旅慧联或合作伙伴由此需承担的成本以及蒙受的损失。首旅慧联有权对违规的会员账户采取包括但不仅限于以下行动：没收账号的所有积分、礼券或取消您目前所享受的会员礼遇；取消账户和您将来参与本会员体系的资格。首享会可以不需对任何个人或第三方负责而随时中断服务。会员服务结束后，首享会将不再对会员承担任何义务，但可以继续保存用户的注册信息及使用首享会服务期间的交易信息。
                    </p>
                    <p>
                      <b>权利义务转让。</b>首旅慧联有权随时将此会员体系下首旅慧联享有的权力和应尽的义务指定或转让给任何其它相关或不相关的实体，其后的全部履行责任归由该实体承担。
                    </p>
                    <p>
                      <b>条款解读。</b>此条款及细则代表了首旅慧联与会员之间关于首享会的合法约束协议。如发生任何争议，此条款及细则将取代在此之前本公司与会员之间的任何口头、书面或其它形式的协议。对本会员体系条款及附则的独家解释权归首旅慧联所有。
                    </p>
                    <p>
                      <b>管辖法律。</b>本协议根据中华人民共和国法律管辖、解释和执行，无论法律规定是否有冲突。其中任何条款与中华人民共和国法律相抵触，则这些条款将完全按法律规定重新解释，而其它条款依旧具有法律效力。首旅慧联保留随时更改上述免责及其他条款的权利。
                    </p>
                    <p className={styles.marginTop20}>生效日期：2017 年 12 月</p>
                  </div>

                </div>
              </div>
            </div>
          :
          null
        }
      </Fragment>

    );
  }
}
export default Activation;

